<template>
	<div>
		<div class="hero risk-bg">
      <div class="inner">
        <h1>{{$t('riskManagementSystemPage.text1')}}</h1>
        <h5 class="subtitle">{{$t('riskManagementSystemPage.text2')}}</h5>
      </div>
    </div>


		<section class="section3">
      <div class="section-inner">
        <h2 class="section-title variant">{{$t('riskManagementSystemPage.text3')}}</h2>
        <div class="spacer"></div>
        <div class="col3-grid text-left line">
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/risk-icon1.svg" alt="" /></div>
            <h5>{{$t('riskManagementSystemPage.text4')}}</h5>
            <ul class="col-list">
              <li>{{$t('riskManagementSystemPage.text5')}}</li>
              <li>{{$t('riskManagementSystemPage.text6')}}</li>
              <li>{{$t('riskManagementSystemPage.text7')}}</li>
							<li>{{$t('riskManagementSystemPage.text8')}}</li>
							<li>{{$t('riskManagementSystemPage.text9')}}</li>
            </ul>
          </div>
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/risk-icon2.svg" alt="" /></div>
            <h5>{{$t('riskManagementSystemPage.text10')}}</h5>
						<ul class="col-list">
							<li>{{$t('riskManagementSystemPage.text11')}}</li>
							<li>{{$t('riskManagementSystemPage.text12')}}</li>
							<li>{{$t('riskManagementSystemPage.text13')}}</li>
							<li>{{$t('riskManagementSystemPage.text14')}}</li>
							<li>{{$t('riskManagementSystemPage.text15')}}</li>
							<li>{{$t('riskManagementSystemPage.text16')}}</li>
						</ul>
          </div>
          <div class="col3-grid-item">
            <div><img src="@/assets/icons/risk-icon3.svg" alt="" /></div>
            <h5>{{$t('riskManagementSystemPage.text17')}}</h5>
						<ul class="col-list">
							<li>{{$t('riskManagementSystemPage.text18')}}</li>
							<li>{{$t('riskManagementSystemPage.text19')}}</li>
							<li>{{$t('riskManagementSystemPage.text20')}}</li>
						</ul>
          </div>
        </div>
      </div>
    </section>



		<section class="section3 light-gray">
      <div class="section-inner">
        <h2 class="section-title">{{$t('riskManagementSystemPage.text21')}}</h2>
        <p>{{$t('riskManagementSystemPage.text22')}}</p>
        <router-link to="contact" class="contact-us"><BtnPrimary text="Contact us" /></router-link>
      </div>
    </section>
	</div>
</template>

<script>
import BtnPrimary from '@/components/BtnPrimary.vue';

export default {
	name: 'RiskManagementSystemPage',
	components: { BtnPrimary },
	data() {
		return {
			
		};
	},

	mounted() {
		
	},

	methods: {
		
	},
};
</script>

<style lang="scss" scoped>

</style>